// extracted by mini-css-extract-plugin
export var magnifier = "search-input-module--magnifier--rnaC9";
export var searchInput = "search-input-module--search-input--MDyb-";
export var wrapper = "search-input-module--wrapper--Wg4qk";